import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <p style={styles.code}>404</p>
        <h1 style={styles.heading}>Page not found</h1>
        <p style={styles.path}>{location.pathname}</p>
        <Link to="/" style={styles.link}>← Back to start</Link>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--color-bg-base)", padding: "var(--space-6)" },
  card: { display: "flex", flexDirection: "column", alignItems: "center", gap: "var(--space-3)", textAlign: "center" },
  code: { fontSize: "var(--text-3xl)", fontWeight: "var(--weight-bold)", color: "var(--color-text-disabled)" },
  heading: { fontSize: "var(--text-xl)", fontWeight: "var(--weight-semibold)", color: "var(--color-text-primary)" },
  path: { fontSize: "var(--text-sm)", color: "var(--color-text-tertiary)", fontFamily: "monospace" },
  link: { fontSize: "var(--text-sm)", color: "var(--color-accent)" },
};
